<template>
  <div class="outer-box">
    <h4>Allow Agency Update Usage Limit</h4>

    <div class="inner-box" style="text-align: left; width: 500px;">
      <select class="hl_input--wrap" type="text" v-model="value">
        <option :value="true">True</option>
        <option :value="false">False</option>
      </select>
      <input class="mt-4 hl_input--wrap " type="text" placeholder="Relationship Number" v-model="relationshipNumber" />
      <button class="btn btn-primary mt-4" @click="allowAgencyUpdateUsageLimit" :disabled="!relationshipNumber || processing">
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else class="capitalize">Allow update usage</span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{
        response
      }}</pre>
    </div>
  </div>
</template>

<script>
import { SaasService } from "@/services";

export default {
  data() {
    return {
      value: false,
      relationshipNumber: '',
      processing: false,
      response: null
    };
  },
  methods: {
    async allowAgencyUpdateUsageLimit() {
      try{
        this.processing = true;
        const response = await SaasService.allowAgencyUpdateUsageLimit(this.relationshipNumber, { value: this.value })
        this.response = response.data
      }
      catch (err) {
          this.response = err.response.data
      }
      finally {
          this.processing = false;
      }
    }
  }
}
</script>
